// Autogenerated file
import ErrorBoundary from './ErrorBoundary.json';

export default {
  ...ErrorBoundary,
};
